/**
 * V-0758 (Fassung 2, 28.09.2026), Paket (c): Zahlart-Auswahl beim Bezahlt-Markieren einer
 * Eingangsrechnung. Eigener Namensraum statt Eintraege in den grossen
 * `web/src/i18n/locales/*.json` — die tragen gerade grosse fremde, uncommittete Aenderungen
 * anderer Sitzungen. Muster: `web/src/components/zahlarten/i18n` (siehe dort fuer die
 * Registrierung in `web/src/i18n/index.ts`).
 *
 * Die Kurzlabels je Zahlweg (kasse/bank/verrechnung) kommen bewusst NICHT nochmal hierher —
 * sie werden aus `zahlarten.zahlwegKurz.*` (Paket (a)) wiederverwendet.
 */
export const incomingInvoicesDe = {
  'incomingInvoices.zahlart.label': 'Zahlart',
  'incomingInvoices.zahlart.hinweis': 'Womit wurde diese Eingangsrechnung tatsächlich beglichen? Ohne Auswahl kann der Beleg nicht als bezahlt markiert werden.',
  'incomingInvoices.zahlart.bitteWaehlen': 'Bitte wählen …',
  'incomingInvoices.zahlart.inaktiv': 'inaktiv',
  'incomingInvoices.zahlart.keineVorhanden': 'Keine Zahlart vorhanden.',
  'incomingInvoices.zahlart.zurZahlartenpflege': 'Zur Zahlarten-Pflege',
  'incomingInvoices.zahlart.fehlt': 'Bitte eine Zahlart auswählen.',
  'incomingInvoices.zahlart.bankZuordnungAktiv': 'Diese Rechnung ist einer Bankzahlung zugeordnet. Bitte die Zuordnung im Zahlungsabgleich lösen.',
  'incomingInvoices.zahlart.bezahltMit': 'Bezahlt mit: {{name}}',
  'incomingInvoices.zahlart.nichtErfasst': 'Zahlart nicht erfasst',
  'incomingInvoices.zahlart.alleBereitsBezahlt': 'Alle ausgewählten Belege sind bereits bezahlt oder archiviert.',
};
